export default function Contact() {
  const contactInfo = [
    { label: 'ADDRESS', value: 'Drammensveien 123', icon: 'ri-map-pin-line' },
    { label: 'CITY', value: 'OSLO', icon: 'ri-building-line' },
    { label: 'ZIP', value: '0277', icon: 'ri-mail-line' },
    { label: 'COUNTRY', value: 'Norway', icon: 'ri-global-line' },
    { label: 'EMAIL', value: 'help@skarpeas.com', icon: 'ri-mail-send-line' },
    { label: 'NUMBER', value: '+1 3632081077', icon: 'ri-phone-line' }
  ];

  return (
    <footer id="contact" className="py-20 px-20 bg-[#0D0D0D] max-w-[1440px] mx-auto">
      <div className="grid grid-cols-5 gap-16 mb-16">
        <div className="col-span-2">
          <h2 className="text-[48px] leading-tight font-serif text-white mb-2">
            Get in Touch
          </h2>
          <h3 className="text-[48px] leading-tight font-serif text-white mb-10">
            With Our Team
          </h3>
          
          <p className="text-base text-[#707070] mb-20">
            We're here to answer your questions
          </p>
        </div>
        
        <div className="col-span-3">
          <div className="grid grid-cols-3 gap-12">
            <div>
              <h4 className="text-sm font-medium text-white mb-6">Company</h4>
              <ul className="space-y-4">
                <li><button onClick={() => document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' })} className="text-base text-[#707070] hover:text-white transition-colors cursor-pointer">Products</button></li>
                <li><button onClick={() => document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' })} className="text-base text-[#707070] hover:text-white transition-colors cursor-pointer">Features</button></li>
                <li><button onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })} className="text-base text-[#707070] hover:text-white transition-colors cursor-pointer">About</button></li>
                <li><span className="text-base text-[#707070]">Careers</span></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-sm font-medium text-white mb-6">Support</h4>
              <ul className="space-y-4">
                <li><span className="text-base text-[#707070]">Documentation</span></li>
                <li><span className="text-base text-[#707070]">Help Center</span></li>
                <li><span className="text-base text-[#707070]">Community</span></li>
                <li><span className="text-base text-[#707070]">Updates</span></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-sm font-medium text-white mb-6">Contact</h4>
              <div className="space-y-6">
                {contactInfo.map((item, index) => (
                  <div key={index}>
                    <p className="text-[11px] uppercase tracking-[2px] text-[#C9A961] mb-2 flex items-center gap-2">
                      <i className={`${item.icon} text-xs`}></i>
                      {item.label}
                    </p>
                    <p className="text-base text-[#707070]">{item.value}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="pt-8 border-t border-[#2A2A2A] flex items-center justify-between">
        <p className="text-sm text-[#707070]">© 2025 Skarpe AS</p>
        <a 
          href="https://readdy.ai/?ref=logo" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-sm text-[#707070] hover:text-white transition-colors cursor-pointer"
        >
          Powered by Readdy
        </a>
      </div>
    </footer>
  );
}
